import React, { useState } from "react";

const StaffAttendanceHistory = () => {
  const [search, setSearch] = useState("");

  const daysInMonth = 31;

  const staffs = [
    {
      id: "EMP001",
      name: "Rajesh Kumar",
      department: "Administration",
      designation: "Principal",
      attendance: [
        "P","P","P","H","P","P","P","P","P","P",
        "H","P","P","P","P","P","P","H","P","P",
        "P","P","P","P","H","P","P","P","P","P","P"
      ]
    },
    {
      id: "EMP002",
      name: "Sujatha Devi",
      department: "Teaching",
      designation: "Teacher",
      attendance: [
        "P","P","A","H","P","P","P","P","P","P",
        "H","P","P","L","P","P","P","H","P","P",
        "P","P","P","P","H","P","P","P","P","P","P"
      ]
    },
    {
      id: "EMP003",
      name: "Mahesh",
      department: "Accounts",
      designation: "Accountant",
      attendance: [
        "A","A","P","H","P","P","P","P","P","P",
        "H","P","P","P","P","P","P","H","P","P",
        "P","P","P","P","H","P","P","P","P","P","P"
      ]
    }
  ];

  const filteredStaff = staffs.filter(
    (staff) =>
      staff.name.toLowerCase().includes(search.toLowerCase()) ||
      staff.id.toLowerCase().includes(search.toLowerCase())
  );

  const getCounts = (attendance) => {
    return {
      present: attendance.filter((x) => x === "P").length,
      absent: attendance.filter((x) => x === "A").length,
      late: attendance.filter((x) => x === "L").length,
      working: attendance.filter((x) => x !== "H").length,
    };
  };

  return (
    <div className="card shadow-sm">

      {/* Header */}
      <div className="card-header">
        <h4 className="mb-0">
          Staff Attendance History
        </h4>
      </div>

      {/* Filters */}
      <div className="card-body border-bottom">
        <div className="row g-3">

          <div className="col-md-2">
            <label className="form-label">
              Academic Year
            </label>
            <select className="form-select">
              <option>All</option>
              <option>2025-2026</option>
              <option>2026-2027</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">
              Month
            </label>
            <select className="form-select">
              <option>All</option>
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
              <option>June</option>
              <option>July</option>
              <option>August</option>
              <option>September</option>
              <option>October</option>
              <option>November</option>
              <option>December</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">
              Department
            </label>
            <select className="form-select">
              <option>All</option>
              <option>Administration</option>
              <option>Teaching</option>
              <option>Accounts</option>
              <option>Transport</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">
              Designation
            </label>
            <select className="form-select">
              <option>All</option>
              <option>Principal</option>
              <option>Teacher</option>
              <option>Accountant</option>
              <option>Driver</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">
              Attendance Status
            </label>
            <select className="form-select">
              <option>All</option>
              <option>Present</option>
              <option>Absent</option>
              <option>Late</option>
              <option>Holiday</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Employee ID"
            />
          </div>

          <div className="col-12 d-flex justify-content-end gap-2">
            <button className="btn btn-primary">
              Search
            </button>

            <button className="btn btn-secondary">
              Reset
            </button>

            <button className="btn btn-success">
              Export Excel
            </button>
          </div>

        </div>
      </div>

      {/* Table Section */}
      <div className="card-body">

        <div className="d-flex justify-content-between align-items-center mb-3">

          <div className="d-flex gap-2">
            <select
              className="form-select"
              style={{ width: "80px" }}
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
          </div>

          <div className="fw-semibold">
            <span className="text-warning me-3">
              H - Holiday
            </span>

            <span className="text-success me-3">
              P - Present
            </span>

            <span className="text-danger me-3">
              A - Absent
            </span>

            <span className="text-primary">
              L - Late
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <label>Search:</label>

            <input
              type="text"
              className="form-control"
              style={{ width: "220px" }}
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
            />
          </div>
        </div>

        {/* Horizontal Scroll Table */}

        <div className="tblScrollX">
          <table
            className="table table-bordered table-sm align-middle mb-0"
            style={{
              minWidth: "2200px",
              whiteSpace: "nowrap"
            }}
          >
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Employee ID</th>
                <th>Staff Name</th>
                <th>Department</th>
                <th>Designation</th>

                {Array.from(
                  { length: daysInMonth },
                  (_, i) => (
                    <th key={i}>
                      {i + 1}
                    </th>
                  )
                )}

                <th>Total Working</th>
                <th>Total Present</th>
                <th>Total Absent</th>
                <th>Total Late</th>
              </tr>
            </thead>

            <tbody>
              {filteredStaff.map(
                (staff, index) => {
                  const counts = getCounts(
                    staff.attendance
                  );

                  return (
                    <tr key={staff.id}>
                      <td>{index + 1}</td>
                      <td>{staff.id}</td>
                      <td>{staff.name}</td>
                      <td>{staff.department}</td>
                      <td>{staff.designation}</td>

                      {staff.attendance.map(
                        (status, i) => (
                          <td
                            key={i}
                            className="text-center fw-bold"
                          >
                            {status === "P" && (
                              <span className="text-success">
                                P
                              </span>
                            )}

                            {status === "A" && (
                              <span className="text-danger">
                                A
                              </span>
                            )}

                            {status === "L" && (
                              <span className="text-primary">
                                L
                              </span>
                            )}

                            {status === "H" && (
                              <span className="text-warning">
                                Sun
                              </span>
                            )}
                          </td>
                        )
                      )}

                      <td>{counts.working}</td>
                      <td>{counts.present}</td>
                      <td>{counts.absent}</td>
                      <td>{counts.late}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default StaffAttendanceHistory;